interface DeliveryOrderProcessCellDelegate
{
    addComments( cell:DeliveryOrderProcessCell, item:any );
}

class DeliveryOrderProcessCell extends UITableViewCell
{
    delegate:DeliveryOrderProcessCellDelegate = null;

    private nameLabel:MUILabel = null;
    private quantityLabel:MUILabel = null;
    private pendingQuantityLabel:MUILabel = null;
    private pendingQuantitySpinLoader:MUIView = null;
    private stockQuantityLabel:MUILabel = null;
    private stockQuantitySpinLoader:MUIView = null;
    private quantityTextField:MUITextField = null;
    private addCommentsButton:MUIButton = null;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.quantityLabel = MUIOutlet(this, "quantity-lbl", "MUILabel");
        this.pendingQuantityLabel = MUIOutlet(this, "pending-quantity-lbl", "MUILabel");
        this.pendingQuantitySpinLoader = MUIOutlet(this, "pending-quantity-spin-loader", "MUIView");
        this.stockQuantityLabel = MUIOutlet(this, "stock-quantity-lbl", "MUILabel");
        this.stockQuantitySpinLoader = MUIOutlet(this, "stock-spin-loader", "MUIView");
        this.quantityTextField = MUIOutlet(this, "deliver-quantity-tf", "MUITextField");

        // this.addCommentsButton = MUIOutlet(this, "add-comments-btn", "MUIButton");
        // this.addCommentsButton.setAction(this, function(){
        //     this.delegate?.addComments(this, this._item);
        // });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:any = null;
    set item( item:any ){
        this._item = item;

        this.nameLabel.text = item[ "Name" ];
        let qty = item[ "Quantity" ] ?? 0;
        this.quantityLabel.text = qty;

        let pending_qty = item[ "PendingQuantity" ];
        this.pendingQuantitySpinLoader.hidden = pending_qty == null ? false : true;
        this.pendingQuantityLabel.text = pending_qty;
        
        let stock_qty = item[ "StockQuantity" ];
        this.stockQuantitySpinLoader.hidden = stock_qty == null ? false : true;
        this.stockQuantityLabel.text = stock_qty;            
        
        if (stock_qty == null || pending_qty == null) this.quantityTextField.text = null;
        else {
            let delivery_qty = stock_qty > qty ? qty : stock_qty - qty;
            this.quantityTextField.text = delivery_qty >= 0 ? delivery_qty : 0;
        }
        
        // this.addCommentsButton.hidden = item[ "HasComments" ] == true;
    }
}